var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrata(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9048 19.0361L28.9132 33.6607L27.7966 32.8945L15.5774 24.1584L14.9361 11.0302L14.8948 10.2253L26.9048 19.0361ZM20.9046 21.1762C20.8725 21.2094 20.8455 21.247 20.8242 21.288C20.7574 21.3966 20.7246 21.5228 20.7304 21.6502C20.7361 21.7776 20.7799 21.9004 20.8563 22.0025C20.9326 22.1047 21.0379 22.1816 21.1584 22.2232C21.279 22.2648 21.4093 22.2692 21.5324 22.2359C21.6912 22.195 21.8277 22.0937 21.913 21.9537C22.0009 21.8106 22.0284 21.6384 21.9895 21.4751C21.9507 21.3117 21.8486 21.1704 21.7056 21.0822C21.5824 21.0012 21.4345 20.9662 21.288 20.9834C21.1415 21.0006 21.0057 21.0689 20.9046 21.1762Z",
    fill: "#36B09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22ZM1.30702 22C1.30702 33.4284 10.5716 42.693 22 42.693C33.4284 42.693 42.693 33.4284 42.693 22C42.693 10.5716 33.4284 1.30702 22 1.30702C10.5716 1.30702 1.30702 10.5716 1.30702 22Z",
    fill: "#4F6C8D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.3761,
    y1: 0.752222,
    x2: 22.3761,
    y2: 2.8206,
    stroke: "#4F6C8D",
    strokeWidth: 0.752137
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 41.1787,
    y1: 21.6239,
    x2: 43.2471,
    y2: 21.6239,
    stroke: "#4F6C8D",
    strokeWidth: 0.752137
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.751953,
    y1: 21.6239,
    x2: 2.82033,
    y2: 21.6239,
    stroke: "#4F6C8D",
    strokeWidth: 0.752137
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 7.3167,
    y1: 6.78525,
    x2: 8.77926,
    y2: 8.24781,
    stroke: "#4F6C8D",
    strokeWidth: 0.752137
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.376068,
    x2: 2.06838,
    y2: -0.376068,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 36.9072 7.05117)",
    stroke: "#4F6C8D",
    strokeWidth: 0.752137
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.376068,
    x2: 2.06838,
    y2: -0.376068,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 8.51465 35.4444)",
    stroke: "#4F6C8D",
    strokeWidth: 0.752137
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 35.7103,
    y1: 35.1785,
    x2: 37.1728,
    y2: 36.641,
    stroke: "#4F6C8D",
    strokeWidth: 0.752137
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 22.3761,
    y1: 41.1796,
    x2: 22.3761,
    y2: 43.248,
    stroke: "#4F6C8D",
    strokeWidth: 0.752137
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrata);
export default __webpack_public_path__ + "static/media/Qrata.ce59f4a54e21b81bb3a97593cf2c4d51.svg";
export { ForwardRef as ReactComponent };